"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnouncementServiceStub = void 0;
const faker = __importStar(require("faker"));
const generateFakeAnnouncement = () => ({
    attachmentUrls: Array.from({
        length: 2,
    }).map(() => faker.internet.url()),
    _id: faker.random.alphaNumeric(20),
    companyId: faker.random.alphaNumeric(20),
    body: faker.random.words(150),
    subject: faker.random.words(10),
    dateOfAnnouncement: faker.date.recent(),
    createdByUser: {
        _id: faker.random.alphaNumeric(20),
        firstName: faker.name.firstName(),
        secondName: faker.name.firstName(),
        thirdName: "",
        familyName: faker.name.lastName(),
        userId: faker.random.alphaNumeric(20),
    },
    includeShareholders: faker.random.boolean(),
    includeNoteholders: faker.random.boolean(),
    includeOptionholders: faker.random.boolean(),
    shareholderIds: Array.from({
        length: 5,
    }).map(() => faker.random.alphaNumeric(20)),
});
class AnnouncementServiceStub {
    getCompanyAnnouncements(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                const announcementList = Array.from({
                    length: 30,
                }).map(() => generateFakeAnnouncement());
                return {
                    status: true,
                    payload: { announcementList, count: 30 },
                    message: "",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    getAnnouncement(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                return {
                    status: true,
                    payload: generateFakeAnnouncement(),
                    message: "",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    getAttachmentSignedUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                status: true,
                payload: faker.internet.url(),
                message: "",
            };
        });
    }
}
exports.AnnouncementServiceStub = AnnouncementServiceStub;
//# sourceMappingURL=AnnouncementServiceStub.js.map